import { toSafeLowerString, toSafeObjectOrNull as toObject, toSafeString } from '@shared/utils';

const normalizeConnectionInteractionSummary = (value) => {
  const source = toObject(value);

  if (!source) {
    return null;
  }

  const id = toSafeString(source?.id || source?.credentialId);
  const label = toSafeString(source?.label || source?.meta?.label || source?.secrets?.label);
  const status = toSafeLowerString(source?.status) || null;
  const isDefault = source?.isDefault === true;

  if (!id && !label && !status) {
    return null;
  }

  return {
    id: id || null,
    label: label || null,
    status,
    isDefault
  };
};

const resolveConnectionSetupAppIcon = (app = {}) => {
  const iconCandidates = [app?.icon, app?.iconUrl, app?.logo, app?.logoUrl, app?.image, app?.imageUrl, app?.avatar, app?.avatarUrl, app?.appIcon, app?.appIconUrl, app?.appLogo, app?.appLogoUrl, app?.brandIcon, app?.brandIconUrl];

  for (const iconCandidate of iconCandidates) {
    const directIconUrl = toSafeString(iconCandidate);

    if (directIconUrl) {
      return directIconUrl;
    }

    if (!iconCandidate || typeof iconCandidate !== 'object' || Array.isArray(iconCandidate)) {
      continue;
    }

    const nestedIconUrl = toSafeString(iconCandidate?.url || iconCandidate?.src || iconCandidate?.icon || iconCandidate?.logo || iconCandidate?.image || iconCandidate?.light || iconCandidate?.dark || iconCandidate?.default);

    if (nestedIconUrl) {
      return nestedIconUrl;
    }
  }

  return null;
};

const resolveConnectionSetupAppDescription = (app = {}) => {
  return toSafeString(app?.description || app?.summary || app?.shortDescription || app?.short_description) || null;
};

const normalizeConnectionSetupPayload = (value) => {
  const payload = toObject(value) || {};
  const app = toObject(payload?.app) || {};
  const setup = toObject(payload?.setup) || {};
  const selectedConnection = normalizeConnectionInteractionSummary(payload?.selectedConnection);
  const targetConnection = normalizeConnectionInteractionSummary(payload?.targetConnection);
  const candidates = Array.isArray(payload?.candidates)
    ? payload.candidates
        .map((candidate) => {
          return normalizeConnectionInteractionSummary(candidate);
        })
        .filter(Boolean)
    : [];

  return {
    kind: toSafeLowerString(payload?.kind || 'connection_setup') || 'connection_setup',
    app: {
      id: toSafeString(app?.id) || null,
      slug: toSafeString(app?.slug) || null,
      name: toSafeString(app?.name || app?.slug || app?.ref) || null,
      ref: toSafeString(app?.ref || app?.slug || app?.id) || null,
      icon: resolveConnectionSetupAppIcon(app),
      description: resolveConnectionSetupAppDescription(app)
    },
    action: {
      ref: toSafeString(payload?.action?.ref || '') || null
    },
    setup: {
      mode: toSafeLowerString(setup?.mode || 'create') || 'create',
      reason: toSafeLowerString(setup?.reason || 'missing_connection') || 'missing_connection',
      ctaLabel: toSafeString(setup?.ctaLabel || ''),
      connectionLabel: toSafeString(setup?.connectionLabel || '') || null,
      credentialId: toSafeString(setup?.credentialId || '') || null,
      errorCode: toSafeString(setup?.errorCode || '') || null,
      errorMessage: toSafeString(setup?.errorMessage || '') || null,
      requestedConnectionRef: toSafeString(setup?.requestedConnectionRef || '') || null,
      resolutionStatus: toSafeLowerString(setup?.resolutionStatus || '') || null
    },
    selectedConnection,
    targetConnection,
    candidates
  };
};

export default normalizeConnectionSetupPayload;
